import React from 'react';
import PropTypes from 'prop-types';
import FormulaireSelectionProjet from '../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import S from '../ProfilTasks/FormulaireTasks/FormulaireTasks.module.scss';

/**
 * Section de configuration du contexte de planification (projet, groupe de tâches)
 */
const TaskPlanningSection = ({
  projectId,
  groupTaches,
  onChange,
  readOnly = false,
}) => {
  return (
    <div className={S.section}>
      <div className={S.champGroupe}>
        <FormulaireSelectionProjet
          preconfigurerProjetId={projectId || null}
          gererProjetId={(id) => onChange('project_id', id)}
          affichageProfil={readOnly}
          disabled={readOnly}
        />
      </div>
      <div className={S.champGroupe}>
        <label className={S.label}>Groupe de tâches</label>
        <ChampDeTexte
          value={groupTaches}
          onChange={(v) => onChange('group_taches', v)}
          placeholder="ex.: base_vie_management"
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

TaskPlanningSection.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  groupTaches: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

TaskPlanningSection.defaultProps = {
  projectId: null,
  readOnly: false,
};

export default React.memo(TaskPlanningSection);
